// 성격/성향 기반 공부법 데이터 (VARK 학습 유형 + MBTI 성격 유형 기반)

export type StudyOptionType =
  | 'V' | 'A' | 'R' | 'K'
  | 'E' | 'I' | 'S' | 'N' | 'T' | 'F' | 'J' | 'P';

export interface StudyQuestion {
  id: string;
  question: string;
  options: {
    value: string;
    label: string;
    type: StudyOptionType;
  }[];
}

export interface StudyProfile {
  type: string;
  name: string;
  description: string;
  strengths: string[];
  weaknesses: string[];
  studyTips: Record<string, string[]>;
  bestEnvironment: string;
  worstHabits: string[];
  recommendation: string;
}

export interface MbtiProfile {
  type: string;
  name: string;
  description: string;
  studyStrengths: string[];
  studyWeaknesses: string[];
  studyStyle: string;
}

// ============ VARK 학습 유형 문항 (26문항) ============
export const varkQuestions: StudyQuestion[] = [
  {
    id: 'q1',
    question: '새로운 개념을 처음 배울 때, 어떤 방법이 가장 잘 이해되나요?',
    options: [
      { value: 'V', label: '도표, 그래프, 마인드맵으로 시각화해서 보는 것', type: 'V' },
      { value: 'A', label: '선생님이나 유튜브 영상으로 설명을 들으며 이해하는 것', type: 'A' },
      { value: 'R', label: '교과서나 참고서를 꼼꼼히 읽으며 이해하는 것', type: 'R' },
      { value: 'K', label: '직접 문제를 풀어보거나 실험해보며 익히는 것', type: 'K' }
    ]
  },
  {
    id: 'q2',
    question: '시험 공부를 할 때 가장 효과적인 방법은?',
    options: [
      { value: 'V', label: '중요 내용을 색깔별로 정리하고 요약 노트를 만드는 것', type: 'V' },
      { value: 'A', label: '핵심 내용을 혼자 소리 내어 읽거나 설명하는 것', type: 'A' },
      { value: 'R', label: '기출문제와 개념 정리집을 반복해서 읽는 것', type: 'R' },
      { value: 'K', label: '문제를 최대한 많이 풀어보며 손으로 익히는 것', type: 'K' }
    ]
  },
  {
    id: 'q3',
    question: '수업에서 중요한 내용을 기억할 때 어떻게 하나요?',
    options: [
      { value: 'V', label: '칠판의 그림이나 PPT 이미지를 기억하려 한다', type: 'V' },
      { value: 'A', label: '선생님의 말투나 강조 부분을 기억한다', type: 'A' },
      { value: 'R', label: '필기한 내용을 다시 읽으며 기억한다', type: 'R' },
      { value: 'K', label: '직접 해본 활동이나 풀었던 문제로 기억한다', type: 'K' }
    ]
  },
  {
    id: 'q4',
    question: '공부할 때 가장 큰 어려움은 무엇인가요?',
    options: [
      { value: 'V', label: '글로만 된 설명은 머릿속에 그림이 그려지지 않아 어렵다', type: 'V' },
      { value: 'A', label: '조용히 책만 보면 집중력이 떨어진다', type: 'A' },
      { value: 'R', label: '강의를 듣기만 하면 나중에 기억이 잘 안 난다', type: 'R' },
      { value: 'K', label: '이론만 공부하면 실제 어떻게 적용하는지 몰라 막막하다', type: 'K' }
    ]
  },
  {
    id: 'q5',
    question: '수학 문제를 풀 때 어떤 방식이 가장 도움이 되나요?',
    options: [
      { value: 'V', label: '그래프나 그림으로 시각화하면 더 잘 풀린다', type: 'V' },
      { value: 'A', label: '풀이 과정을 혼자 말하면서 풀면 실수가 줄어든다', type: 'A' },
      { value: 'R', label: '공식과 개념을 완벽히 외우고 적용한다', type: 'R' },
      { value: 'K', label: '비슷한 유형 문제를 많이 풀어보는 반복 연습이 최고다', type: 'K' }
    ]
  },
  {
    id: 'q6',
    question: '영어 단어를 외울 때 어떤 방법이 가장 잘 외워지나요?',
    options: [
      { value: 'V', label: '단어를 그림이나 이미지와 연상해서 외운다', type: 'V' },
      { value: 'A', label: '단어를 소리 내어 반복해서 읽으며 외운다', type: 'A' },
      { value: 'R', label: '단어를 직접 쓰고 예문을 정리하며 외운다', type: 'R' },
      { value: 'K', label: '단어를 실제 문장이나 상황에 사용해보며 외운다', type: 'K' }
    ]
  },
  {
    id: 'q7',
    question: '복습할 때 주로 어떤 방식을 사용하나요?',
    options: [
      { value: 'V', label: '노트를 색깔별로 다시 정리하고 도식화한다', type: 'V' },
      { value: 'A', label: '배운 내용을 누군가에게 설명하듯 말해본다', type: 'A' },
      { value: 'R', label: '요약본을 다시 정독하고 밑줄을 친다', type: 'R' },
      { value: 'K', label: '다시 한 번 문제를 풀어보거나 활동을 반복한다', type: 'K' }
    ]
  },
  {
    id: 'q8',
    question: '노트 정리를 할 때 나의 스타일은?',
    options: [
      { value: 'V', label: '그림, 도표, 색상을 활용해 시각적으로 정리한다', type: 'V' },
      { value: 'A', label: '내용을 요약해서 말로 설명하듯 적는다', type: 'A' },
      { value: 'R', label: '깔끔하게 글과 문장 중심으로 정리한다', type: 'R' },
      { value: 'K', label: '핵심만 간단히 적고 바로 문제를 푼다', type: 'K' }
    ]
  },
  {
    id: 'q9',
    question: '설명을 들을 때 가장 잘 이해되는 상황은?',
    options: [
      { value: 'V', label: '그림이나 PPT 자료를 함께 보여줄 때', type: 'V' },
      { value: 'A', label: '말로 차근차근 설명해줄 때', type: 'A' },
      { value: 'R', label: '글로 정리된 자료를 읽을 때', type: 'R' },
      { value: 'K', label: '직접 따라 해보거나 예시를 보여줄 때', type: 'K' }
    ]
  },
  {
    id: 'q10',
    question: '긴 글을 읽을 때 어떤 습관이 있나요?',
    options: [
      { value: 'V', label: '내용을 머릿속에 그림이나 구조로 그려본다', type: 'V' },
      { value: 'A', label: '소리 내어 읽거나 속으로 또박또박 읽는다', type: 'A' },
      { value: 'R', label: '밑줄 치고 핵심 문장을 메모하며 읽는다', type: 'R' },
      { value: 'K', label: '중간중간 멈추고 내용을 직접 요약해본다', type: 'K' }
    ]
  },
  {
    id: 'q11',
    question: '실험이나 실습 수업에서 나는 어떤 편인가요?',
    options: [
      { value: 'V', label: '실험 과정을 그림이나 다이어그램으로 정리한다', type: 'V' },
      { value: 'A', label: '선생님의 실험 설명을 주의 깊게 듣는다', type: 'A' },
      { value: 'R', label: '실험 이론과 원리를 먼저 읽고 이해한다', type: 'R' },
      { value: 'K', label: '직접 실험해보는 것을 가장 좋아한다', type: 'K' }
    ]
  },
  {
    id: 'q12',
    question: '발표를 준비할 때 가장 신경 쓰는 것은?',
    options: [
      { value: 'V', label: '시각적으로 보기 좋은 슬라이드와 그림 준비', type: 'V' },
      { value: 'A', label: '발표 내용을 소리 내어 연습하고 말투 다듬기', type: 'A' },
      { value: 'R', label: '발표 원고를 꼼꼼히 작성하고 정리', type: 'R' },
      { value: 'K', label: '직접 시연하거나 시범을 보여주는 것', type: 'K' }
    ]
  },
  {
    id: 'q13',
    question: '시험 직전 마지막 점검은 어떻게 하나요?',
    options: [
      { value: 'V', label: '요약 노트와 도표를 훑어본다', type: 'V' },
      { value: 'A', label: '핵심 내용을 소리 내어 되뇌인다', type: 'A' },
      { value: 'R', label: '오답 노트와 정리본을 다시 읽는다', type: 'R' },
      { value: 'K', label: '중요 문제를 몇 개 다시 풀어본다', type: 'K' }
    ]
  },
  {
    id: 'q14',
    question: '오답을 분석할 때 나의 방법은?',
    options: [
      { value: 'V', label: '틀린 문제를 도표나 색으로 구분해 정리한다', type: 'V' },
      { value: 'A', label: '틀린 이유를 소리 내어 설명해본다', type: 'A' },
      { value: 'R', label: '틀린 이유와 개념을 글로 자세히 적는다', type: 'R' },
      { value: 'K', label: '비슷한 문제를 다시 풀어보며 바로 교정한다', type: 'K' }
    ]
  },
  {
    id: 'q15',
    question: '새로운 어플이나 기술을 배울 때 나는?',
    options: [
      { value: 'V', label: '화면과 아이콘을 보고 직관적으로 파악한다', type: 'V' },
      { value: 'A', label: '사용법을 설명하는 영상이나 음성을 듣는다', type: 'A' },
      { value: 'R', label: '사용 설명서나 매뉴얼을 먼저 읽는다', type: 'R' },
      { value: 'K', label: '일단 직접 눌러보고 사용해본다', type: 'K' }
    ]
  },
  {
    id: 'q16',
    question: '지리나 지도가 나오는 내용을 공부할 때?',
    options: [
      { value: 'V', label: '지도를 직접 보며 위치와 형태를 기억한다', type: 'V' },
      { value: 'A', label: '지역 특징을 설명으로 듣고 기억한다', type: 'A' },
      { value: 'R', label: '지명과 특징을 글로 정리해 외운다', type: 'R' },
      { value: 'K', label: '실제 지도를 그려보거나 답사하며 익힌다', type: 'K' }
    ]
  },
  {
    id: 'q17',
    question: '역사 사건을 공부할 때 효과적인 방법은?',
    options: [
      { value: 'V', label: '연대기 타임라인 표를 만들어 본다', type: 'V' },
      { value: 'A', label: '역사 이야기를 듣거나 영상으로 본다', type: 'A' },
      { value: 'R', label: '사건의 배경과 전개를 글로 정리한다', type: 'R' },
      { value: 'K', label: '역사 관련 영화나 드라마, 체험을 통해 익힌다', type: 'K' }
    ]
  },
  {
    id: 'q18',
    question: '문법을 공부할 때 나에게 맞는 방법은?',
    options: [
      { value: 'V', label: '문장 구조를 도식이나 다이어그램으로 그린다', type: 'V' },
      { value: 'A', label: '예문을 소리 내어 읽으며 감각을 익힌다', type: 'A' },
      { value: 'R', label: '문법 규칙을 정리해 반복해서 읽는다', type: 'R' },
      { value: 'K', label: '직접 문장을 만들어보며 연습한다', type: 'K' }
    ]
  },
  {
    id: 'q19',
    question: '문제 풀 때 실수를 줄이기 위한 나만의 방법은?',
    options: [
      { value: 'V', label: '문제를 도식화하거나 그림으로 정리한다', type: 'V' },
      { value: 'A', label: '풀이 과정을 혼자 소리 내어 말한다', type: 'A' },
      { value: 'R', label: '문제 조건을 꼼꼼히 다시 읽고 확인한다', type: 'R' },
      { value: 'K', label: '비슷한 유형을 반복해서 풀며 익숙해진다', type: 'K' }
    ]
  },
  {
    id: 'q20',
    question: '집중이 안 될 때 다시 집중하는 나만의 방법은?',
    options: [
      { value: 'V', label: '공부 내용을 색색의 도표로 다시 정리한다', type: 'V' },
      { value: 'A', label: '음악을 틀거나 소리 내어 읽는다', type: 'A' },
      { value: 'R', label: '필기한 내용을 차분히 다시 읽는다', type: 'R' },
      { value: 'K', label: '자리에서 움직이며 문제를 풀어본다', type: 'K' }
    ]
  },
  {
    id: 'q21',
    question: '개념을 암기할 때 가장 잘 외워지는 방법은?',
    options: [
      { value: 'V', label: '핵심 단어를 그림이나 기호로 변환한다', type: 'V' },
      { value: 'A', label: '리듬이나 노래처럼 소리 내어 외운다', type: 'A' },
      { value: 'R', label: '여러 번 쓰고 읽으며 외운다', type: 'R' },
      { value: 'K', label: '개념을 활용하는 문제를 풀며 외운다', type: 'K' }
    ]
  },
  {
    id: 'q22',
    question: '독서할 때 가장 편한 방식은?',
    options: [
      { value: 'V', label: '삽화나 그림이 있는 책을 선호한다', type: 'V' },
      { value: 'A', label: '오디오북으로 듣는 것을 좋아한다', type: 'A' },
      { value: 'R', label: '종이책으로 글을 직접 읽는 것을 좋아한다', type: 'R' },
      { value: 'K', label: '읽으면서 메모하고 표시하며 적극적으로 읽는다', type: 'K' }
    ]
  },
  {
    id: 'q23',
    question: '토론이나 모둠 수업에서 나는?',
    options: [
      { value: 'V', label: '토론 내용을 칠판이나 도표로 정리하고 싶다', type: 'V' },
      { value: 'A', label: '말로 의견을 주고받는 것을 즐긴다', type: 'A' },
      { value: 'R', label: '자료를 읽고 글로 의견을 정리해본다', type: 'R' },
      { value: 'K', label: '직접 활동이나 역할극을 통해 참여한다', type: 'K' }
    ]
  },
  {
    id: 'q24',
    question: '공부 계획을 세울 때 나에게 맞는 방식은?',
    options: [
      { value: 'V', label: '달력이나 플래너에 색깔별로 표시한다', type: 'V' },
      { value: 'A', label: '계획을 소리 내어 다짐하며 세운다', type: 'A' },
      { value: 'R', label: '상세한 목록을 글로 작성한다', type: 'R' },
      { value: 'K', label: '계획보다 바로 시작해서 조금씩 진행한다', type: 'K' }
    ]
  },
  {
    id: 'q25',
    question: '모르는 정보를 찾을 때 나는?',
    options: [
      { value: 'V', label: '영상이나 그림, 인포그래픽 자료를 찾는다', type: 'V' },
      { value: 'A', label: '유튜브 강의나 음성 설명을 듣는다', type: 'A' },
      { value: 'R', label: '책이나 문서, 백과사전을 읽는다', type: 'R' },
      { value: 'K', label: '직접 검색해서 실험하거나 적용해본다', type: 'K' }
    ]
  },
  {
    id: 'q26',
    question: '나에게 가장 유용한 공부 도구는?',
    options: [
      { value: 'V', label: '색깔 펜, 포스트잇, 마인드맵 도구', type: 'V' },
      { value: 'A', label: '녹음기, 헤드폰, 음성 강의', type: 'A' },
      { value: 'R', label: '노트, 교과서, 요약 정리집', type: 'R' },
      { value: 'K', label: '문제집, 실습 키트, 타이머', type: 'K' }
    ]
  }
];

// ============ MBTI 성격 유형 문항 (24문항, 4차원 × 6문항) ============
export const mbtiQuestions: StudyQuestion[] = [
  // E/I 차원 (에너지 방향) - 6문항
  {
    id: 'm1',
    question: '방과 후 에너지를 충전하는 방식은?',
    options: [
      { value: 'E', label: '친구들과 어울리며 이야기할 때 에너지가 생긴다', type: 'E' },
      { value: 'I', label: '혼자만의 시간을 가질 때 에너지가 생긴다', type: 'I' }
    ]
  },
  {
    id: 'm2',
    question: '공부는 주로 어떤 방식으로 하나요?',
    options: [
      { value: 'E', label: '스터디 그룹이나 친구와 함께 하는 게 더 잘 된다', type: 'E' },
      { value: 'I', label: '혼자 조용히 집중하는 게 더 잘 된다', type: 'I' }
    ]
  },
  {
    id: 'm3',
    question: '새로운 사람이 많은 자리에서 나는?',
    options: [
      { value: 'E', label: '먼저 다가가 말을 거는 편이다', type: 'E' },
      { value: 'I', label: '먼저 다가가기보다 상황을 지켜보는 편이다', type: 'I' }
    ]
  },
  {
    id: 'm4',
    question: '고민이 있을 때 어떻게 하나요?',
    options: [
      { value: 'E', label: '주변 사람들에게 말하며 함께 해결한다', type: 'E' },
      { value: 'I', label: '혼자 곰곰이 생각하며 해결한다', type: 'I' }
    ]
  },
  {
    id: 'm5',
    question: '수업 중 발표나 토론에 대해 나는?',
    options: [
      { value: 'E', label: '적극적으로 의견을 내는 편이다', type: 'E' },
      { value: 'I', label: '신중하게 생각한 후 말하는 편이다', type: 'I' }
    ]
  },
  {
    id: 'm6',
    question: '주말에 가장 좋아하는 활동은?',
    options: [
      { value: 'E', label: '친구를 만나거나 밖에서 활동한다', type: 'E' },
      { value: 'I', label: '집에서 혼자만의 시간을 보낸다', type: 'I' }
    ]
  },
  // S/N 차원 (정보 수집) - 6문항
  {
    id: 'm7',
    question: '새로운 개념을 배울 때 더 관심 가는 것은?',
    options: [
      { value: 'S', label: '구체적인 사실과 실제 사례', type: 'S' },
      { value: 'N', label: '숨은 의미와 큰 그림, 가능성', type: 'N' }
    ]
  },
  {
    id: 'm8',
    question: '문제를 풀 때 선호하는 방식은?',
    options: [
      { value: 'S', label: '배운 공식과 절차를 차근차근 적용한다', type: 'S' },
      { value: 'N', label: '새로운 아이디어나 응용 방법을 떠올린다', type: 'N' }
    ]
  },
  {
    id: 'm9',
    question: '글을 읽을 때 더 기억에 남는 것은?',
    options: [
      { value: 'S', label: '구체적인 사실, 숫자, 세부 내용', type: 'S' },
      { value: 'N', label: '전체적인 흐름과 숨은 의미', type: 'N' }
    ]
  },
  {
    id: 'm10',
    question: '수업 중 더 재미있는 순간은?',
    options: [
      { value: 'S', label: '실제 예시와 구체적인 설명을 들을 때', type: 'S' },
      { value: 'N', label: '새로운 아이디어나 상상력을 발휘할 때', type: 'N' }
    ]
  },
  {
    id: 'm11',
    question: '공부 방법에 대해 나는?',
    options: [
      { value: 'S', label: '검증된 방법을 꾸준히 반복하는 것을 선호한다', type: 'S' },
      { value: 'N', label: '새로운 방법을 시도해보는 것을 좋아한다', type: 'N' }
    ]
  },
  {
    id: 'm12',
    question: '내가 더 신뢰하는 것은?',
    options: [
      { value: 'S', label: '직접 경험하고 확인한 사실', type: 'S' },
      { value: 'N', label: '직관과 예감, 미래의 가능성', type: 'N' }
    ]
  },
  // T/F 차원 (의사결정) - 6문항
  {
    id: 'm13',
    question: '친구가 고민을 털어놓을 때 나는?',
    options: [
      { value: 'T', label: '원인을 분석하고 해결책을 제시한다', type: 'T' },
      { value: 'F', label: '먼저 공감하고 감정을 나눠준다', type: 'F' }
    ]
  },
  {
    id: 'm14',
    question: '결정을 내릴 때 더 중요하게 생각하는 것은?',
    options: [
      { value: 'T', label: '논리적이고 객관적인 기준', type: 'T' },
      { value: 'F', label: '사람들의 감정과 관계', type: 'F' }
    ]
  },
  {
    id: 'm15',
    question: '비판을 받았을 때 나는?',
    options: [
      { value: 'T', label: '비판의 내용이 맞는지 논리적으로 따져본다', type: 'T' },
      { value: 'F', label: '비판 자체에 마음이 상하기도 한다', type: 'F' }
    ]
  },
  {
    id: 'm16',
    question: '갈등 상황에서 나는?',
    options: [
      { value: 'T', label: '옳고 그름을 명확히 가리고 싶다', type: 'T' },
      { value: 'F', label: '서로의 감정이 상하지 않게 하고 싶다', type: 'F' }
    ]
  },
  {
    id: 'm17',
    question: '에세이를 쓸 때 더 잘 쓰는 주제는?',
    options: [
      { value: 'T', label: '논리적인 분석과 근거를 제시하는 글', type: 'T' },
      { value: 'F', label: '감정과 가치를 담은 글', type: 'F' }
    ]
  },
  {
    id: 'm18',
    question: '나는 주로 어떤 칭찬을 들을 때?',
    options: [
      { value: 'T', label: '"논리적이고 똑똑하다"는 말을 자주 듣는다', type: 'T' },
      { value: 'F', label: '"따뜻하고 배려심 있다"는 말을 자주 듣는다', type: 'F' }
    ]
  },
  // J/P 차원 (생활 방식) - 6문항
  {
    id: 'm19',
    question: '공부 계획을 세울 때 나는?',
    options: [
      { value: 'J', label: '계획을 세우고 그대로 지키는 것이 안심된다', type: 'J' },
      { value: 'P', label: '상황에 맞게 유동적으로 조절하는 편이다', type: 'P' }
    ]
  },
  {
    id: 'm20',
    question: '과제나 숙제를 할 때 나는?',
    options: [
      { value: 'J', label: '미리미리 끝내는 편이다', type: 'J' },
      { value: 'P', label: '마감 직전에 몰아서 하는 편이다', type: 'P' }
    ]
  },
  {
    id: 'm21',
    question: '정리정돈에 대해 나는?',
    options: [
      { value: 'J', label: '물건과 시간을 계획적으로 정리한다', type: 'J' },
      { value: 'P', label: '자유롭게 두는 편이 더 편하다', type: 'P' }
    ]
  },
  {
    id: 'm22',
    question: '예상치 못한 일이 생기면?',
    options: [
      { value: 'J', label: '당황스럽고 계획이 틀어져 불편하다', type: 'J' },
      { value: 'P', label: '오히려 재미있고 새로운 기회라고 생각한다', type: 'P' }
    ]
  },
  {
    id: 'm23',
    question: '시험 준비 방식은?',
    options: [
      { value: 'J', label: '일정을 세워 차근차근 준비한다', type: 'J' },
      { value: 'P', label: '상황을 보며 그때그때 집중해서 준비한다', type: 'P' }
    ]
  },
  {
    id: 'm24',
    question: '일을 마무리하는 것에 대해 나는?',
    options: [
      { value: 'J', label: '끝까지 마무리 짓는 것에 만족감을 느낀다', type: 'J' },
      { value: 'P', label: '끝내기보다 새로운 것을 시작하는 게 더 즐겁다', type: 'P' }
    ]
  }
];

// ============ VARK 학습 유형 프로필 ============
export const studyProfiles: Record<string, StudyProfile> = {
  V: {
    type: 'V',
    name: '시각형 학습자',
    description: '도표, 그래프, 이미지로 정보를 처리할 때 가장 효과적입니다. 색상과 공간적 배치로 기억하는 편입니다.',
    strengths: ['마인드맵 작성 능력', '도표·그래프 해석', '필기 노트 정리', '전체 구조 파악'],
    weaknesses: ['긴 텍스트 집중력 저하', '말로만 하는 설명 이해 어려움'],
    studyTips: {
      '국어': [
        '소설 구조를 타임라인으로 그려보세요',
        '문학 작품 주제·배경·인물 관계를 마인드맵으로 정리',
        '글의 흐름을 단락별 키워드 다이어그램으로 표현',
        '핵심 어휘는 컬러 포스트잇으로 벽에 붙여두기'
      ],
      '수학': [
        '함수 그래프를 직접 그려가며 이해하세요',
        '풀이 단계를 번호별 박스로 시각화',
        '오답 노트를 컬러풀하게 꾸미고 오류 패턴 색으로 분류',
        '공식은 자신만의 다이어그램으로 재해석'
      ],
      '영어': [
        '단어를 이미지와 함께 연상하여 외우기 (그림 사전 활용)',
        '문장 구조를 브래킷 다이어그램으로 표시',
        '독해 지문의 논리 흐름을 화살표 도식으로 요약'
      ],
      '과학': [
        '실험 과정을 직접 그린 플로차트로 정리',
        '세포, 원자 구조 등 복잡한 개념은 직접 그려서 암기',
        '단원별 개념 지도(concept map) 작성'
      ],
      '사회': [
        '역사 연대기를 타임라인으로 작성',
        '지도를 활용한 지리 개념 정리',
        '사회 현상을 인과관계 다이어그램으로 표현'
      ]
    },
    bestEnvironment: '정리된 책상, 화이트보드 또는 큰 노트, 색 펜 구비, 자연광이나 밝은 조명',
    worstHabits: ['글자만 빽빽한 교과서를 무작정 읽기', '필기 없이 강의만 듣기'],
    recommendation: 'Notion, 마인드마이스터 등 시각화 도구나 아이패드 필기 앱을 활용해보세요. 공부 내용을 "인포그래픽"으로 만드는 연습도 큰 도움이 됩니다!'
  },
  A: {
    type: 'A',
    name: '청각형 학습자',
    description: '소리와 언어를 통해 정보를 가장 잘 처리합니다. 설명을 듣거나 혼잣말로 복습할 때 기억이 오래 갑니다.',
    strengths: ['강의 내용 기억력', '토론·발표 능력', '언어 감각', '음악적 리듬 활용'],
    weaknesses: ['조용한 텍스트 기반 공부 시 집중력 저하', '긴 독서 과제 어려움'],
    studyTips: {
      '국어': [
        '시나 소설을 소리 내어 읽어보세요',
        '배운 내용을 스스로 설명하는 "티칭백" 연습',
        '문법 개념을 리듬이나 노래로 외우기',
        '독서 후 내용을 혼자 말로 요약하는 습관'
      ],
      '수학': [
        '풀이 과정을 소리 내어 설명하며 풀기',
        '공식을 읊조리며 외우기',
        '친구에게 수학 개념 설명해주는 "선생님 놀이"',
        '틀린 이유를 큰 소리로 분석하기'
      ],
      '영어': [
        '단어·문장을 반복해서 소리 내어 읽기',
        '영어 팟캐스트나 TED 강연 청취',
        '셰도잉(shadowing) 연습으로 발음과 문법 동시 습득',
        '영어 노래로 표현 익히기'
      ],
      '과학': [
        '실험 과정을 혼자 설명하며 외우기',
        'EBS, 유튜브 과학 강의 적극 활용',
        '개념을 친구나 가족에게 설명하며 복습'
      ],
      '사회': [
        '역사적 사건을 이야기(스토리텔링)로 만들기',
        '사회·지리 개념을 혼잣말로 복습',
        '뉴스 청취로 현실 연결 복습'
      ]
    },
    bestEnvironment: '적당한 배경 소음(카페 소음, 백색 소음 앱), 헤드폰, 소리 내어 읽을 수 있는 공간',
    worstHabits: ['무음 환경에서 강제로 집중 시도', '읽기만 하고 소리 활용 안 하기'],
    recommendation: '공부한 내용을 음성 녹음하고 이동 중 반복 청취해보세요. 유튜브 강의와 오디오북을 적극 활용하고, 스터디 그룹에서 서로 설명하는 활동이 큰 효과를 발휘합니다!'
  },
  R: {
    type: 'R',
    name: '읽기/쓰기형 학습자',
    description: '글과 텍스트를 통한 학습이 가장 효과적입니다. 꼼꼼한 독서와 필기로 개념을 정리하는 것을 선호합니다.',
    strengths: ['꼼꼼한 텍스트 분석', '체계적 필기 능력', '논술·서술형 강점', '광범위한 독서'],
    weaknesses: ['시각화 자료 활용 부족', '구두 표현·발표 어려움'],
    studyTips: {
      '국어': [
        '어휘와 문법을 예문과 함께 직접 써보기',
        '독서 후 서평이나 요약문 작성 습관',
        '문학 작품 분석 글을 직접 써보기',
        '좋은 문장을 필사하며 문장 감각 기르기'
      ],
      '수학': [
        '개념 노트에 정의·공식·예제를 자신의 언어로 재정리',
        '오답 노트에 틀린 이유와 올바른 사고과정을 상세히 서술',
        '풀이 과정을 단계별로 설명문처럼 작성하기'
      ],
      '영어': [
        '단어장을 직접 작성하며 예문도 함께 기록',
        '독해 후 주요 표현을 직접 써서 외우기',
        '영어 일기나 요약문 쓰기 연습',
        '받아쓰기로 듣기·쓰기 동시 연습'
      ],
      '과학': [
        '실험 보고서를 꼼꼼하게 직접 작성',
        '교과서 내용을 자신의 말로 다시 쓰기',
        '개념 설명을 문장으로 정리하는 "설명문 노트"'
      ],
      '사회': [
        '역사 사건을 에세이 형식으로 정리',
        '개념 정의를 직접 문장으로 써보기',
        '사회 현상에 대한 본인 의견 서술 연습'
      ]
    },
    bestEnvironment: '조용한 공간, 질 좋은 필기구, 줄 있는 노트, 교과서와 참고서 구비',
    worstHabits: ['강의만 듣고 필기 없이 넘어가기', '요약 없이 교과서만 여러 번 읽기'],
    recommendation: '개념을 정리한 후 그 내용을 블로그나 노션에 올리는 "학습 일기"를 써보세요. 쓰면서 더 깊이 이해되고, 나중에 복습 자료로도 완벽합니다!'
  },
  K: {
    type: 'K',
    name: '체험형 학습자',
    description: '직접 해보고 경험하면서 배울 때 가장 효과적입니다. 실습·문제풀이·프로젝트에서 빠른 습득을 보입니다.',
    strengths: ['실험·실습 능력', '문제 풀이 속도', '적용 및 응용 능력', '프로젝트 수행'],
    weaknesses: ['이론·개념 학습 인내심 부족', '세부 사항 집중 어려움'],
    studyTips: {
      '국어': [
        '배운 문법으로 직접 문장 만들어보기',
        '문학 작품 내용을 역할극이나 단편 글로 재창작',
        '독서 후 독후감이나 내 의견 에세이 작성',
        '모의 토론·발표 연습으로 국어 실력 키우기'
      ],
      '수학': [
        '문제를 최대한 많이 풀어보는 것이 가장 좋습니다',
        '개념 이해 후 바로 관련 문제 10개 풀기',
        '실생활에서 수학 개념 찾기 (건축, 통계 등)',
        '수학 어플(Photomath, Geogebra)로 직접 그려보기'
      ],
      '영어': [
        '배운 표현으로 바로 짧은 대화문 만들기',
        '영어 관련 유튜브에 영어로 댓글 달기',
        '일상에서 영어 라벨·표지판 찾아보기',
        '영어 게임이나 퀴즈로 단어 외우기'
      ],
      '과학': [
        '학교 실험 적극 참여 및 실험 결과 예측하기',
        '일상 현상에서 과학 원리 찾아보기',
        '간단한 홈 실험(베이킹소다+식초 등) 해보기',
        '과학 팟캐스트나 실험 유튜브 채널 구독'
      ],
      '사회': [
        '배운 역사 배경을 담은 영화나 드라마 시청',
        '뉴스 현안을 사회 개념으로 분석해보기',
        '가상 정책 입안 프로젝트 수행',
        '사회 문제 해결 아이디어 실제 제안해보기'
      ]
    },
    bestEnvironment: '다양한 활동이 가능한 공간, 타이머(포모도로), 자주 환경 전환, 친구와 문제 풀기',
    worstHabits: ['이론만 계속 읽다 지치기', '문제 풀이 없이 개념만 반복 정리'],
    recommendation: '공부할 내용을 "미니 프로젝트"로 만들어보세요. 예를 들어 사회 개념으로 실제 정책 제안서를 작성하거나, 수학으로 실생활 문제를 풀어보는 것입니다. 직접 해보는 탐구가 곧 세특 내용이 됩니다!'
  }
};

// ============ MBTI 16유형 프로필 ============
export const mbtiProfiles: Record<string, MbtiProfile> = {
  INTJ: {
    type: 'INTJ',
    name: '전략가',
    description: '독립적이고 전략적인 사고로 목표를 향해 체계적으로 나아가는 유형입니다.',
    studyStrengths: ['장기적인 학습 계획 수립', '개념 간 연결과 패턴 파악', '독학 능력', '깊이 있는 집중'],
    studyWeaknesses: ['과도한 완벽주의', '남에게 도움 요청이 어려움', '지나친 독단적 판단'],
    studyStyle: '큰 목표를 세우고 스스로 로드맵을 설계해보세요. 방대한 지식을 구조화해서 정리하면 최상의 성과를 냅니다. 다만 혼자 파고들기보다 가끔은 피드백을 받는 것이 필요해요.'
  },
  INTP: {
    type: 'INTP',
    name: '논리술사',
    description: '호기심이 많고 논리적으로 깊이 탐구하는 것을 즐기는 유형입니다.',
    studyStrengths: ['원리와 개념 이해', '논리적 분석력', '독창적 아이디어', '호기심 기반 학습'],
    studyWeaknesses: ['마무리 부족', '지나친 이론 탐구', '실천력 부족'],
    studyStyle: '단순 암기보다 "왜?"라는 질문으로 원리를 파고들 때 빛을 발합니다. 다만 완벽한 이해를 기다리다 늦어지지 않도록, 일정 시간 안에 정리하고 넘어가는 연습이 필요해요.'
  },
  ENTJ: {
    type: 'ENTJ',
    name: '통솔자',
    description: '목표 지향적이고 추진력이 강하며 효율적으로 성과를 내는 유형입니다.',
    studyStrengths: ['목표 설정과 실행력', '효율적인 시간 관리', '리더십', '논리적 설득'],
    studyWeaknesses: ['성급한 결론', '감정적 배려 부족', '지나친 경쟁 의식'],
    studyStyle: '명확한 목표와 보상 체계를 만들면 놀라운 집중력을 발휘합니다. 스터디 그룹을 이끌어보면 배운 것을 정리하고 복습하는 데도 큰 도움이 돼요.'
  },
  ENTP: {
    type: 'ENTP',
    name: '변론가',
    description: '아이디어가 풍부하고 새로운 가능성을 탐색하는 것을 즐기는 유형입니다.',
    studyStrengths: ['창의적 발상', '빠른 이해력', '토론과 논쟁 능력', '다각적 사고'],
    studyWeaknesses: ['산만함', '끈기 부족', '반복 학습 지루해함'],
    studyStyle: '다양한 관점에서 토론하며 배울 때 효과적입니다. 다만 아이디어만 내다 끝나지 않도록, 하나를 선택해 끝까지 완성하는 훈련이 필요해요.'
  },
  INFJ: {
    type: 'INFJ',
    name: '통찰자',
    description: '깊은 통찰력과 의미 추구로 내면의 가치를 따라가는 유형입니다.',
    studyStrengths: ['깊은 의미 이해', '직관적 통찰', '계획적 실천', '공감 능력'],
    studyWeaknesses: ['과도한 완벽주의', '지나친 자기 비판', '번아웃 위험'],
    studyStyle: '단순 지식보다 "왜 배우는가"라는 의미를 연결할 때 몰입합니다. 스스로를 너무 몰아붙이지 말고, 적절한 휴식과 자기 돌봄을 병행하세요.'
  },
  INFP: {
    type: 'INFP',
    name: '중재자',
    description: '이상적이고 가치 지향적이며 풍부한 감성과 창의성을 지닌 유형입니다.',
    studyStrengths: ['창의적 글쓰기', '가치 중심의 동기', '깊은 감정 이해', '상상력'],
    studyWeaknesses: ['현실적 세부에 약함', '미루는 습관', '비판에 민감'],
    studyStyle: '자신의 가치와 연결된 주제를 공부할 때 놀라운 몰입을 보입니다. 감성과 상상력을 살린 방식(스토리텔링, 일기)으로 정리하면 기억에 오래 남아요.'
  },
  ENFJ: {
    type: 'ENFJ',
    name: '선도자',
    description: '사람을 이끌고 돕는 데 탁월하며 따뜻한 소통을 중시하는 유형입니다.',
    studyStrengths: ['설명과 가르치기', '협업 능력', '공감과 동기 부여', '소통'],
    studyWeaknesses: ['남에게 과도한 신경', '자기 공부 소홀', '비판 회피'],
    studyStyle: '배운 내용을 다른 사람에게 가르치고 설명할 때 가장 잘 익힙니다. 스터디 리더를 맡거나 튜터링을 해보세요. 다만 남을 돕느라 내 공부를 놓치지 않도록 균형이 필요해요.'
  },
  ENFP: {
    type: 'ENFP',
    name: '활동가',
    description: '열정적이고 상상력이 풍부하며 다양한 가능성을 즐기는 유형입니다.',
    studyStrengths: ['풍부한 아이디어', '열정적 몰입', '창의적 표현', '사람 친화력'],
    studyWeaknesses: ['집중력 분산', '마무리 부족', '세부 계획 미흡'],
    studyStyle: '흥미로운 주제에는 놀라운 열정을 쏟습니다. 다양하게 시도하되, 핵심 과제부터 처리하는 우선순위 설정과 마무리 습관을 들이는 게 중요해요.'
  },
  ISTJ: {
    type: 'ISTJ',
    name: '현실주의자',
    description: '성실하고 책임감이 강하며 체계적으로 일을 처리하는 유형입니다.',
    studyStrengths: ['꾸준함과 성실성', '체계적 정리', '집중력', '신뢰성'],
    studyWeaknesses: ['변화에 둔함', '융통성 부족', '새로운 방법 거부'],
    studyStyle: '규칙적이고 체계적인 반복 학습이 가장 잘 맞습니다. 정해진 루틴을 지키면 탄탄한 실력을 쌓습니다. 가끔은 새로운 공부법도 시도해보면 더 성장할 수 있어요.'
  },
  ISFJ: {
    type: 'ISFJ',
    name: '수호자',
    description: '꼼꼼하고 헌신적이며 조용히 맡은 일을 완수하는 유형입니다.',
    studyStrengths: ['꼼꼼한 정리', '책임감', '인내심', '세부 기억력'],
    studyWeaknesses: ['자기 주장 부족', '과도한 부담', '변화 스트레스'],
    studyStyle: '꼼꼼한 노트 정리와 반복 학습이 강점입니다. 다만 스스로에게 너무 완벽을 요구하지 말고, 모르는 것은 주변에 도움을 요청하는 연습을 해보세요.'
  },
  ESTJ: {
    type: 'ESTJ',
    name: '경영자',
    description: '조직적이고 현실적이며 실행력이 뛰어난 유형입니다.',
    studyStrengths: ['계획 수립과 실행', '조직적 관리', '현실적 판단', '결단력'],
    studyWeaknesses: ['융통성 부족', '남의 의견 무시', '과도한 통제'],
    studyStyle: '구체적인 계획표와 체크리스트를 활용하면 최고의 성과를 냅니다. 다만 틀에 얽매이지 않고 때로는 유연하게 조정하는 것도 중요해요.'
  },
  ESFJ: {
    type: 'ESFJ',
    name: '집정관',
    description: '따뜻하고 사교적이며 조화와 협력을 중시하는 유형입니다.',
    studyStrengths: ['협력적 학습', '성실한 과제 수행', '배려와 공감', '구체적 실천'],
    studyWeaknesses: ['남의 평가에 민감', '의존성', '갈등 회피'],
    studyStyle: '친구와 함께하는 스터디와 소통 속에서 잘 배웁니다. 다만 남에게 맞추느라 자신의 학습 속도를 놓치지 않도록 주의하세요.'
  },
  ISTP: {
    type: 'ISTP',
    name: '장인',
    description: '실용적이고 문제 해결에 능하며 독립적으로 탐구하는 유형입니다.',
    studyStrengths: ['실습과 적용', '문제 해결력', '냉철한 분석', '독립성'],
    studyWeaknesses: ['이론 학습 지루함', '장기 계획 부족', '표현 부족'],
    studyStyle: '직접 만들어보고 실험하며 배울 때 가장 잘 익힙니다. 이론을 실생활 문제와 연결해보면 흥미가 붙어요. 장기 목표를 세우는 습관을 보완하면 좋습니다.'
  },
  ISFP: {
    type: 'ISFP',
    name: '모험가',
    description: '감각적이고 예술적이며 유연하게 순간을 즐기는 유형입니다.',
    studyStrengths: ['예술적 감각', '관찰력', '유연한 적응', '진솔한 표현'],
    studyWeaknesses: ['계획 부족', '미루는 습관', '비판에 민감'],
    studyStyle: '감각과 예술을 활용한 방식(그림, 음악, 영상)으로 배울 때 효과적입니다. 다만 계획을 세우고 꾸준히 실천하는 습관을 함께 들이면 더 좋아요.'
  },
  ESTP: {
    type: 'ESTP',
    name: '사업가',
    description: '즉흥적이고 행동력이 강하며 현장에서 배우는 것을 좋아하는 유형입니다.',
    studyStrengths: ['빠른 실행력', '현장 감각', '위기 대처', '실용적 판단'],
    studyWeaknesses: ['이론 경시', '지속성 부족', '충동성'],
    studyStyle: '앉아서 듣는 것보다 직접 활동하며 배울 때 효과적입니다. 다만 이론적 기초를 소홀히 하면 한계가 오니, 기본 개념 정리를 병행하세요.'
  },
  ESFP: {
    type: 'ESFP',
    name: '연예인',
    description: '활기차고 친화적이며 즐겁게 경험하며 배우는 유형입니다.',
    studyStrengths: ['활발한 참여', '사람들과의 시너지', '긍정 에너지', '표현력'],
    studyWeaknesses: ['집중력 부족', '계획 미흡', '깊이 있는 학습 부족'],
    studyStyle: '재미와 활동을 결합한 학습이 잘 맞습니다. 역할극, 게임, 그룹 활동을 활용해보세요. 다만 즐거움에만 치우치지 않도록 목표를 분명히 세우는 게 중요해요.'
  }
};

// ============ 통합 문항 (VARK + MBTI = 50문항) ============
export const studyQuestions: StudyQuestion[] = [...varkQuestions, ...mbtiQuestions];